var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "menu__burger",
        _vm.theme,
        {
          vertical: _vm.isMobileVertical && !_vm.embedded,
          landscape: _vm.isMobileLandscape && !_vm.embedded,
          "menu__burger--embedded": _vm.embedded,
          "menu__burger--open": _vm.isPopupOpen || _vm.isJackpotPopupOpen,
        },
      ],
      on: { click: _vm.toggleClose },
    },
    [_c("span", { staticClass: "menu__burger__span" })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }